var valueElementType = {
    select: 'option',
    radio: 'input[type="radio"]',
};
function getOptions(optionsEls) {
    var select = [];
    var radio = [];
    for (var i = 0; i < optionsEls.length; i++) {
        var optionEl = optionsEls[i];
        var wrappers = optionEl.matches('[data-variant-option-value-wrapper]')
            ? [optionEl]
            : Array.prototype.slice.call(optionEl.querySelectorAll('[data-variant-option-value-wrapper]'));
        var values = optionEl.matches('[data-variant-option-value]')
            ? [optionEl]
            : Array.prototype.slice.call(optionEl.querySelectorAll('[data-variant-option-value]'));
        if (!values.length)
            break;
        var option = {
            option: optionEl,
            wrappers: wrappers,
            values: values,
        };
        if (values[0].matches(valueElementType.select)) {
            select.push(option);
        }
        else if (values[0].matches(valueElementType.radio)) {
            radio.push(option);
        }
    }
    return {
        select: select,
        radio: radio,
    };
}
function getOptionsState(product, selectOptions, radioOptions, currentSelectedValue) {
    var options = product.options.map(function () {
        return false;
    });
    selectOptions.forEach(function (_ref) {
        var option = _ref.option;
        if (option.value !== '') {
            options[parseInt(option.dataset.variantOptionIndex, 10)] = option.value;
        }
    });
    radioOptions.forEach(function (_ref2) {
        var values = _ref2.values;
        values.forEach(function (value) {
            if (value.checked) {
                options[parseInt(value.dataset.variantOptionValueIndex, 10)] = value.value;
            }
        });
    });
    // just selecting the available options
    const variant = getVariantFromOptionsState(product.variants, options);
    if (!variant && currentSelectedValue) {
        const optionsWithVariant = product.variants.find((variant) => variant.options.includes(currentSelectedValue));
        const variantOptions = getOptionsFromVariant(optionsWithVariant);
        const currentSelectedValueIndex = variantOptions.indexOf(currentSelectedValue);
        for (const index in variantOptions) {
            const optionValue = variantOptions[index];
            options[index] = optionValue;
            if (currentSelectedValueIndex !== index) {
                const option = product.options[index];
                jQuery(`input[name="${option}"][value="${optionValue}"]`).prop('checked', true);
            }
        }
    }
    return options;
}
const getOptionsFromVariant = (variant) => { var _a; return (((_a = variant === null || variant === void 0 ? void 0 : variant.options) === null || _a === void 0 ? void 0 : _a.length) > 1 ? variant.options.filter((option) => option !== 'Default Title') : variant === null || variant === void 0 ? void 0 : variant.options) || []; };
function getVariantFromOptionsState(variants, optionsState) {
    for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        const options = getOptionsFromVariant(variant);
        var isVariant = options.every(function (option, index) {
            return option === optionsState[index];
        });
        if (isVariant)
            return variant; // We found the variant
    }
    return false;
}
function _getVariant(variants, options) {
    return variants.find(function (variant) {
        const currentOptions = getOptionsFromVariant(variant);
        return currentOptions.every(function (option, index) {
            return option === options[index];
        });
    });
}
function _setOptionsMap(product, optionsState, optionsMap, option1, option2 = null, option3 = null) {
    var options = [option1, option2, option3].filter(function (option) {
        return !!option;
    });
    var variant = _getVariant(product.variants, options);
    var variantOptionMatches = options.filter(function (option, index) {
        return option === optionsState[index];
    }).length;
    var isCurrentVariant = variantOptionMatches === product.options.length;
    var isNeighbor = variantOptionMatches === product.options.length - 1;
    for (var i = 0; i < options.length; i++) {
        var option = options[i];
        if (option) {
            var _optionsMap$i$option = optionsMap[i][option], setByCurrentVariant = _optionsMap$i$option.setByCurrentVariant, setByNeighbor = _optionsMap$i$option.setByNeighbor, accessible = _optionsMap$i$option.accessible, available = _optionsMap$i$option.available;
            if (variant) {
                accessible = variant.available || accessible; // The current variant is always
                // the priority for option availability
                if (isCurrentVariant) {
                    setByCurrentVariant = true;
                    available = variant.available;
                }
                else if (!setByCurrentVariant && isNeighbor) {
                    // If the variant is a neighbor
                    // And the option doesn't belong to the variant
                    // Use its availability information for the option
                    // If multiple neighbors exist, prefer true
                    available = setByNeighbor ? available || variant.available : variant.available;
                    setByNeighbor = true;
                }
            }
            else if (isCurrentVariant) {
                // Catch case where current variant doesn't exist
                // Ensure availability is false
                setByCurrentVariant = true;
                available = false;
            }
            else if (!setByCurrentVariant && isNeighbor) {
                // Catch case where neighbor doesn't exist
                // Ensure availability is false
                // If multiple neighbors exist, prefer true
                available = setByNeighbor ? available : false;
                setByNeighbor = true;
            } // If the option isn't set by either
            // the current variant or a neighbor
            // default to general accessibility
            if (!setByCurrentVariant && !setByNeighbor) {
                available = accessible;
            }
            optionsMap[i][option] = {
                setByCurrentVariant: setByCurrentVariant,
                setByNeighbor: setByNeighbor,
                accessible: accessible,
                available: available,
            };
        }
    }
    return optionsMap;
}
function getOptionsMap(product, optionsState) {
    var optionsMap = product.options.map(function () {
        return {};
    });
    for (var i = 0; i < product.options.length; i++) {
        for (var j = 0; j < product.variants.length; j++) {
            var variant = product.variants[j];
            var option = variant.options[i];
            optionsMap[i][option] = {
                setByCurrentVariant: false,
                setByNeighbor: false,
                accessible: false,
                available: false,
            };
        }
    }
    var option1Values = optionsMap.length >= 1 ? Object.keys(optionsMap[0]) : [];
    var option2Values = optionsMap.length >= 2 ? Object.keys(optionsMap[1]) : [];
    var option3Values = optionsMap.length >= 3 ? Object.keys(optionsMap[2]) : [];
    option1Values.forEach(function (option1Value) {
        option2Values.forEach(function (option2Value) {
            option3Values.forEach(function (option3Value) {
                optionsMap = _setOptionsMap(product, optionsState, optionsMap, option1Value, option2Value, option3Value);
            });
            if (!option3Values.length) {
                optionsMap = _setOptionsMap(product, optionsState, optionsMap, option1Value, option2Value);
            }
        });
        if (!option2Values.length) {
            optionsMap = _setOptionsMap(product, optionsState, optionsMap, option1Value);
        }
    });
    return optionsMap;
}
class Variants {
    // onChangeFn: () => any;
    constructor(product, variantsEl, optionsEls, config) {
        this.onVariantChange = (callback) => {
            if (this.callbacks.indexOf(callback) >= 0)
                return;
            this.callbacks.push(callback);
        };
        this.offVariantChange = (callback) => {
            var index = this.callbacks.indexOf(callback);
            if (index === -1)
                return;
            this.callbacks.splice(index, 1);
        };
        this.unload = () => {
            this.events.forEach(({ el, fn }) => el.removeEventListener('change', fn));
        };
        this._updateOptions = (option) => {
            const target = option === null || option === void 0 ? void 0 : option.currentTarget;
            var product = this.product;
            var optionsState = getOptionsState(this.product, this.selectOptions, this.radioOptions, target === null || target === void 0 ? void 0 : target.value);
            var variant = getVariantFromOptionsState(product.variants, optionsState);
            var optionsMap = getOptionsMap(product, optionsState);
            this.variantsEl.value = variant ? variant.id : '';
            this._updateSelectOptions(optionsMap);
            this._updateRadioOptions(optionsMap);
            var event = new Event('change', {
                bubbles: true,
                cancelable: false,
            });
            this.variantsEl.dispatchEvent(event);
            var data = {
                option,
                optionsMap: optionsMap,
                product: product,
                previousVariant: this.previousVariant,
                currentVariant: variant,
                optionsState: optionsState,
            };
            this.callbacks.forEach((callback) => callback(data));
            var switchVariantEvent = new CustomEvent('shopify-variants:switch-variant', {
                cancelable: true,
                bubbles: true,
                detail: data,
            });
            window.dispatchEvent(switchVariantEvent);
            this.previousVariant = variant;
        };
        this._updateSelectOptions = (optionsMap) => {
            if (this.selectOptions.length === 0) {
                return;
            }
            for (var i = 0; i < this.product.options.length; i++) {
                var select = this.selectOptions.find(({ option }) => {
                    if (parseInt(option.dataset.variantOptionIndex, 10) === i) {
                        return true;
                    }
                    return false;
                });
                if (select) {
                    var fragment = document.createDocumentFragment();
                    var { option, wrappers, values } = select;
                    for (var j = values.length - 1; j >= 0; j--) {
                        var wrapper = wrappers[j];
                        var optionValue = values[j];
                        var value = optionValue.value;
                        var available = value in optionsMap[i] && optionsMap[i][value].available;
                        var accessible = value in optionsMap[i] && optionsMap[i][value].accessible;
                        var isChooseOption = value === '';
                        optionValue.disabled = isChooseOption || (this.config.disableUnavailableOptions && !accessible);
                        optionValue.dataset.variantOptionAccessible = i === 0 || accessible;
                        optionValue.dataset.variantOptionAvailable = i === 0 || available;
                        if (i !== 0 && !available) {
                            wrapper.style.display = 'none';
                        }
                        else {
                            wrapper.style.display = 'inline-block';
                        }
                        if (this.config.removeUnavailableOptions && (accessible || isChooseOption)) {
                            fragment.insertBefore(wrapper, fragment.firstElementChild);
                        }
                    }
                    if (this.config.removeUnavailableOptions) {
                        option.innerHTML = '';
                        option.appendChild(fragment);
                    }
                    var chosenValue = values.find((value) => value.selected);
                    option.dataset.variantOptionChosenValue = chosenValue && chosenValue.value !== '' ? chosenValue.value : false;
                }
            }
        };
        this._updateRadioOptions = (optionsMap) => {
            if (this.radioOptions.length === 0) {
                return;
            }
            for (var i = 0; i < this.product.options.length; i++) {
                var radios = this.radioOptions.find(({ option }) => {
                    if (parseInt(option.dataset.variantOptionIndex, 10) === i) {
                        return true;
                    }
                    return false;
                });
                if (radios) {
                    var fragment = document.createDocumentFragment();
                    var { option, wrappers, values } = radios;
                    for (var j = 0; j < values.length; j++) {
                        var wrapper = wrappers[j];
                        var optionValue = values[j];
                        var value = optionValue.value;
                        var available = value in optionsMap[i] && optionsMap[i][value].available;
                        var accessible = value in optionsMap[i] && optionsMap[i][value].accessible;
                        optionValue.disabled = this.config.disableUnavailableOptions && !accessible;
                        optionValue.dataset.variantOptionAccessible = i === 0 || accessible;
                        optionValue.dataset.variantOptionAvailable = i === 0 || available;
                        if (i !== 0 && !available) {
                            wrapper.style.display = 'none';
                        }
                        else {
                            wrapper.style.display = 'inline-block';
                        }
                        if (this.config.removeUnavailableOptions && accessible) {
                            fragment.appendChild(wrapper);
                        }
                    }
                    if (this.config.removeUnavailableOptions) {
                        option.innerHTML = '';
                        option.appendChild(fragment);
                    }
                    var chosenValue = values.find((value) => value.checked);
                    option.dataset.variantOptionChosenValue = chosenValue ? chosenValue.value : false;
                }
            }
        };
        this.config = Object.assign({ disableUnavailableOptions: true, removeUnavailableOptions: false }, config);
        this.events = [];
        this.callbacks = [];
        this.product = product;
        this.variantsEl = variantsEl;
        var _getOptions = getOptions(optionsEls);
        this.selectOptions = _getOptions.select;
        this.radioOptions = _getOptions.radio;
        this.previousVariant = this.currentVariant;
        // this.onChangeFn = () => this._updateOptions();
        this.selectOptions.forEach(({ option }) => {
            option.addEventListener('change', this._updateOptions);
            this.events.push({
                el: option,
                fn: this._updateOptions,
            });
        });
        this.radioOptions.forEach(({ values }) => {
            values.forEach((value) => {
                value.addEventListener('change', this._updateOptions);
                this.events.push({
                    el: value,
                    fn: this._updateOptions,
                });
            });
        });
        this._updateOptions();
    }
    get isDefaultVariant() {
        return this.product.variants[0].public_title === null;
    }
    get isInIndeterminateState() {
        return getOptionsState(this.product, this.selectOptions, this.radioOptions).some((optionState) => !optionState);
    }
    get currentVariant() {
        if (this.isDefaultVariant) {
            return this.product.variants[0];
        }
        return getVariantFromOptionsState(this.product.variants, getOptionsState(this.product, this.selectOptions, this.radioOptions));
    }
}
function updateLabels(el) {
    const optionsEls = el.querySelectorAll('[data-variant-option]');
    for (let i = 0; i < optionsEls.length; i++) {
        const optionsEl = optionsEls[i];
        const optionsNameEl = optionsEl.parentElement.querySelector('[data-variant-option-name]');
        if (optionsNameEl) {
            optionsNameEl.dataset.variantOptionChosenValue = optionsEl.dataset.variantOptionChosenValue;
            if (optionsEl.dataset.variantOptionChosenValue !== 'false') {
                optionsNameEl.innerHTML = optionsNameEl.dataset.variantOptionName;
                const optionNameValueSpan = optionsNameEl.querySelector('span');
                if (optionNameValueSpan) {
                    optionNameValueSpan.innerHTML = optionsEl.dataset.variantOptionChosenValue;
                }
            }
            else {
                optionsNameEl.innerHTML = optionsNameEl.dataset.variantOptionChooseName;
            }
        }
    }
}
export default class ShopifyVariantsUI {
    constructor(el, product, config = {}) {
        this._isDefaultVariant = el.matches('input[data-variants]');
        this._product = product;
        if (this._isDefaultVariant)
            return;
        const variantsEl = el.querySelector('select[data-variants]');
        const optionsEls = el.querySelectorAll('[data-variant-option]');
        this._shopifyVariants = new Variants(product, variantsEl, optionsEls, config);
        updateLabels(el);
        this._shopifyVariants.onVariantChange(() => updateLabels(el));
    }
    get isDefaultVariant() {
        return this._isDefaultVariant || this._shopifyVariants.isDefaultVariant;
    }
    get isInIndeterminateState() {
        return this._isDefaultVariant ? false : this._shopifyVariants.isInIndeterminateState;
    }
    get currentVariant() {
        return this._isDefaultVariant ? this._product.variants[0] : this._shopifyVariants.currentVariant;
    }
    onVariantChange(callback) {
        if (!this._shopifyVariants)
            return;
        this._shopifyVariants.onVariantChange(callback);
    }
    offVariantChange(callback) {
        if (!this._shopifyVariants)
            return;
        this._shopifyVariants.offVariantChange(callback);
    }
    unload() {
        if (this._shopifyVariants) {
            this._shopifyVariants.unload();
        }
    }
}
